import React, { Component } from "react";
import Search from "../../../../common/components/search-text/search-text";
import Button from "../../../button-classic/button-classic";
import { connect } from "react-redux";
import ACTIONS from "../../../../common/action_constant";
import Delete from "../../../../assets/images/delete.svg";
import Edit from "../../../../assets/images/edit.svg";
import { withRouter } from "react-router-dom";
import { getItemFromSessionStorage } from "Utils/sessionStorage";
import { getEmail, getUserId } from "Utils/common";
import AddPharmaTankerMaster from "./add-pharma-tanker-master";

class PharmaTankerMaster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      offset: 0,
      limit: 10,
      pharmaMaterialData: [],
      productListData:[],
      count: 20,
    };
  }

  componentDidMount() {
    this.getPharmaMaterialMasterData();
    this.getInventoryItem();
  }

  getPharmaMaterialMasterData() {
    const { dispatch, companyId } = this.props;
    const { search, offset, limit } = this.state;
    let param = `?companyId=${companyId}&limit=${limit}&offset=${offset}`;
    if (search) {
      param += `&search=${search}`;
    }
    dispatch({
      type: ACTIONS.PLANTS.GET_PHARMA_MATERIAL_MASTER,
      param,
      onSuccess: (res) => {
        this.setState({ pharmaMaterialData: res && res.list });
      },
    });
  }

  changeHandler = (value) => {
    this.setState({ search: value });
  };

  toggleAdd = () => {
    const { isOpen } = this.state;
    this.setState({ isOpen: !isOpen, editData: "" });
  };

  onSavePharmaMaterialMasterData = (data) => {
    const { dispatch } = this.props;
    dispatch({
      type: ACTIONS.PLANTS.ADD_PHARMA_MATERIAL_MASTER,
      data,

      onSuccess: () => {
        this.setState({ isOpen: false }, this.getPharmaMaterialMasterData());
      },
    });
  };

  onSearch = () => {
    this.setState({ offset: 0 }, this.getPharmaMaterialMasterData);
  };

  onUpdatePharmaMaterialMasterData = (data) => {
    const previousData = getItemFromSessionStorage("previousPharmaMaterialName");
    previousData["update_flag"] = true;
    previousData["user_email"] = getEmail();
    previousData["user_id"] = getUserId();
    const { dispatch } = this.props;
    const payload = {
      ...data,
      previous_data: previousData,
    };
    dispatch({
      type: ACTIONS.PLANTS.UPDATE_PHARMA_MATERIAL_MASTER,
      data: payload,
      onSuccess: () => {
        this.setState(
          { isOpen: false, editData: "" },
          this.getPharmaMaterialMasterData
        );
      },
    });
  };

  editPharmaMaterialMaster = (data) => {
    this.setState({
      editData: data,
      isOpen: true,
    });
  };

  deletePharmaMaterialMaster = (data) => {
    const { dispatch } = this.props;
    dispatch({
      type: ACTIONS.PLANTS.DELETE_PHARMA_MATERIAL_MASTER,
      data: data,
      onSuccess: () => {
        this.getPharmaMaterialMasterData();
      },
    });
  };

  getInventoryItem = (search) => {
		const company_id = this.props.companyId;
		let param = `${company_id}&count=${this.state.count}&offset=${this.state.offset}`;
		if(search) {
			param += `&search=${search}`;
		}
		const { dispatch } = this.props;
		dispatch({ type : ACTIONS.MASTER.INVENTORY_ITEM.GET_INVENTORY_ITEM, param, company_id ,
      
    onSuccess: (data) => {
				this.setState({ productListData: data.list && data.list.productMasters})
		}}
    );
	}

  previous = () => {
    if (this.state.offset >= this.state.limit) {
      this.setState(
        (prevState) => ({
          offset: prevState.offset - prevState.limit,
        }),
        this.getPharmaMaterialMasterData
      );
    }
  };

  next = () => {
    this.setState(
      (prevState) => ({
        offset: prevState.offset + prevState.limit,
      }),
      this.getPharmaMaterialMasterData
    );
  };

  clearFilterOnCancel = () => {
    this.setState({ search: "", offset: 0 }, this.getPharmaMaterialMasterData);
  };

  handleOnClickForAuditBtn = () => {
    const { history, companyId } = this.props;
    const masterType = 31;
    const navUrl = `/auditScreen/${companyId}/${masterType}`;
    history.push(navUrl);
  };

  render() {
    const { pharmaMaterialData } = this.state;
    return (
      <div className={"location-network"}>
        <div>
          <div style={{ display: "block", paddingBottom: "15px" }}>
            <Search
              id="search"
              value={this.state.search}
              placeholder="Search..."
              changeHandler={this.changeHandler}
              click={this.onSearch}
              canClear={this.state.search !== ""}
              handleClearFilter={this.clearFilterOnCancel}
            />
            <Button value={"+ Add Pharma Tank Material"} click={this.toggleAdd} />
            <button
              className="button-classic"
              onClick={this.handleOnClickForAuditBtn}
            >
              Audit
            </button>
          </div>
        </div>
        <table className={"chain-details-section"}>
          <tr className={"list-section header"}>
            <td className={"tabel-header vol-th"}>Material Name/Code</td>
            <td className={"tabel-header vol-th"}>Material Description</td>
            <td className={"tabel-header vol-th"}>Tank No</td>
            <td className={"tabel-header vol-th"}>Actions</td>
          </tr>

          {(pharmaMaterialData || []).map((raw, sIndex) => {
            return (
              <div className={"list-section content"} key={`route_${sIndex}`}>
                <div
                  className={"tabel-header vol-td"}
                  style={{ textWrap: "wrap" }}
                >
                  {raw.material}
                </div>
                <div className={"tabel-header vol-td"}>{raw.material_desc}</div>
                <div className={"tabel-header vol-td"}>{raw.tank_no}</div>
                
                <div className={"tabel-header vol-act"}>
                  <div
                    className={"action-icon"}
                    style={{ backgroundImage: `url(${Edit})` }}
                    onClick={() => this.editPharmaMaterialMaster(raw)}
                  />
                  <div
                    className={"action-icon"}
                    style={{ backgroundImage: `url(${Delete})` }}
                    onClick={() => this.deletePharmaMaterialMaster(raw)}
                  />
                </div>
              </div>
            );
          })}
        </table>
        <div className="submit-section-pagination">
          <div className="next">
            <Button value="Next" click={this.next} />
          </div>
          <div className="pre">
            <Button value="Previous" click={this.previous} />
          </div>
        </div>
        {this.state.isOpen && (
          <AddPharmaTankerMaster
            toggleAdd={this.toggleAdd}
            onSave={this.onSavePharmaMaterialMasterData}
            companyId={this.props.companyId}
            editData={this.state.editData}
            onUpdate={this.onUpdatePharmaMaterialMasterData}
            getInventoryItem={this.getInventoryItem}
            productListData={this.state.productListData}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    // productList: state.master.itemList,
  };
};

export default connect(mapStateToProps)(withRouter(PharmaTankerMaster));
